const PRECURSOR_NAMES = new Set([
  "nyr hrammr",
  "dragon's wing",
  "dragon's wisdom",
  "dragon's gaze",
  "dragon's argument",
  "dragon's flight",
  "dragon's voice",
  "dragon's claw",
  "dragon's persuasion",
  "dragon's rending",
  "dragon's insight",
  "dragon's tail",
  "dragon's scale",
  "dragon's bite",
  "dragon's weight",
  "dragon's breath",
  "dragon's fang",
  "dusk",
  "carcharias",
  "zap",
  "the hunter",
  "the chosen",
  "spark",
  "dawn",
  "leaf of kudzu",
  "the legend",
  "tooth of frostfang",
  "chaos gun",
  "the colossus",
  "the energizer",
  "the lover",
  "storm",
  "rage",
  "howl",
  "venom",
  "the bard",
  "rodgort's flame",
]);

const toLowerString = (value) => String(value || "").trim().toLowerCase();

const labelDefByKey = new Map();

export const labelDefs = [
  { key: "Skins", match: (item) => toLowerString(item?.name).includes("skin") },
  { key: "Tonics", match: (item) => toLowerString(item?.name).includes("tonic") },
  { key: "Dyes", match: (item) => toLowerString(item?.name).includes("dye") },
  { key: "Precursors", match: (item) => PRECURSOR_NAMES.has(toLowerString(item?.name)) },
  { key: "Crafting Materials", match: (item) => item?.type === "CraftingMaterial" },
  { key: "Containers", match: (item) => item?.type === "Container" },
];

labelDefs.forEach((definition) => {
  labelDefByKey.set(definition.key, definition);
});

export function createDefaultLabelFilters(defaultValue = 0) {
  return Object.fromEntries(labelDefs.map(({ key }) => [key, defaultValue]));
}

export function toggleTriStateLabelFilter(filters, key) {
  const currentValue = filters?.[key] ?? 0;
  const nextValue = currentValue === 0 ? 1 : currentValue === 1 ? -1 : 0;
  return {
    ...filters,
    [key]: nextValue,
  };
}

export function clearLabelFilters() {
  return createDefaultLabelFilters();
}

export function filterItemsByLabels(items, labelFilters) {
  let filteredItems = items || [];

  const activeIncludes = Object.entries(labelFilters || {})
    .filter(([, value]) => value === 1)
    .map(([key]) => key);
  const activeExcludes = Object.entries(labelFilters || {})
    .filter(([, value]) => value === -1)
    .map(([key]) => key);

  if (activeIncludes.length > 0) {
    filteredItems = filteredItems.filter((item) =>
      activeIncludes.some((labelKey) => {
        const def = labelDefByKey.get(labelKey);
        return def && def.match(item);
      }),
    );
  }

  if (activeExcludes.length > 0) {
    filteredItems = filteredItems.filter(
      (item) =>
        !activeExcludes.some((labelKey) => {
          const def = labelDefByKey.get(labelKey);
          return def && def.match(item);
        }),
    );
  }

  return filteredItems;
}

export function filterItems(items, { labelFilters, searchTerm } = {}) {
  const normalizedSearch = toLowerString(searchTerm);
  const labelFilteredItems = filterItemsByLabels(items, labelFilters);

  if (!normalizedSearch) {
    return labelFilteredItems;
  }

  return labelFilteredItems.filter((item) => toLowerString(item?.name).includes(normalizedSearch));
}
